module.exports = __webpack_public_path__ + "img/support-account.b7c301a0.svg";